<!--
 * @Author: hookshuang
 * @Date: 2021-12-21 17:34:08
 * @LastEditTime: 2022-03-29 09:40:59
 * @FilePath: /zhulogic-design-cloud-next/src/App.vue
 * @Description: 
-->
<template>
  <div id="app">
    <nav-header v-if="tipshow"></nav-header>
    <router-view
      :style="tipshow ? { 'margin-top': 0 + 'px' } : ''"
    ></router-view>
    <common-footer
      v-if="tipshow && showBottom && TipShowBottom"
      :BASIC_URL="baseUrl"
    ></common-footer>
    <zhulogic-afifx v-show="tipshow"></zhulogic-afifx>
  </div>
</template>

<script>
import navHeader from "./components/header";
import zhulogicAfifx from "./components/afifx";
import { Below_IE10 } from "./utils";
import { setTimeout } from "timers";
import CommonFooter from "./components/packages/components/footer/footer.vue";
export default {
  data() {
    return {
      showBottom: false,
      isShowFooter: false,
      baseUrl: {
        baseOld: process.env.VUE_APP_OLD_BASIC_URL,
        baseNext: process.env.VUE_APP_NEXT_BASIC_URL,
        baseNuxt: process.env.VUE_APP_NUXT_BASIC_URL,
      },
    };
  },
  name: "app",
  components: {
    navHeader,
    zhulogicAfifx,
    CommonFooter,
  },
  methods: {
    /* 延迟显示底部 */
    showBottomHandle() {
      this.showBottom = false;
      setTimeout(() => {
        this.showBottom = true;
      }, 3000);
    },
  },
  computed: {
    startLoading() {
      return this.$store.state.startLoading > 0;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    errorLoading() {
      return this.$store.state.errorLoading;
    },
    tipshow() {
      return this.$store.state.TipShow;
    },
    /* 底部是否显示 */
    TipShowBottom() {
      return this.$store.state.TipShowBottom;
    },
  },
  created() {
    if (this.$route.path !== "/sign") {
      this.isShowFooter = true;
    }
  },
  mounted() {
    this.showBottomHandle();
  },
  watch: {
    globalLoading: function () {
      if (this.errorLoading > 0) {
        this.$Loading.error();
        return false;
      }
      if (this.startLoading && this.globalLoading > 0) {
        this.$Loading.start();
      }
      if (this.globalLoading == 0) {
        this.$Loading.finish();
      }
    },
    $route: function (to, from) {
      this.showBottomHandle();
    },
  },
};
</script>
